import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { sharedHelper } from '@/utils';

export const LabelService = {
    getAllLabels,
    getLabel,
    updateLabel,
    updateLabelStatus,
    createLabel
};

const MODULE = {
    LABEL: 'labels',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllLabels(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.LABEL}`, requestOptions)
}

export function getLabel(id) {
    return apiHelper(API_URL).get(`/${MODULE.LABEL}/${id}`)
}

export function updateLabel(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'color', data.color);
    sharedHelper.appendIfNotNull(formData, 'description', data.description);
    formData.append('_method', "put");

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.text);
    });
    return apiHelper(API_URL).post(`/${MODULE.LABEL}/${data.id}`, formData)
}

export function createLabel(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'color', data.color);
    sharedHelper.appendIfNotNull(formData, 'description', data.description);

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.name);
    });

    return apiHelper(API_URL).post(`/${MODULE.LABEL}`, formData)
}

export function updateLabelStatus(data) {

    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.LABEL}/${data.id}`, requestOptions)
}

